export const HistorialPuntosTabla =[
    
    {
      Header: "Ítem",
      accessor: "Guia"
    },
    {
        Header: "Puntos",
        accessor: "Puntos"
    },
    {
      Header: "Fecha Movimiento",
      accessor: "fecingeshp"
    },
    {
        Header: "Observación",
        accessor: "observacion_descuento"
    }
  ];


  export const HistorialPuntosInicial={
    Puntos:"0",
    Guia:"-",
    observacion_descuento:"-"
  }